<template>
	<Modal :show="true" centered size="md" title="Comprobante" @hide="$emit('hide', flags.reload)">
		<ValidationObserver ref="form">
			<div class="form-group">
				<label for="" class="form-label">Motivo:</label>
				<InputTextArea v-model="form.motivo" rules="required|max:100" name="Motivo" vid="motivo" :rows="5"></InputTextArea>
			</div>
			<div class="form-group">
				<button class="btn btn-danger btn-block" @click="onAnular" :disabled="loading">Anular</button>
			</div>
		</ValidationObserver>
	</Modal>
</template>

<script>
import InputTextArea from "../../shared/components/InputTextArea.vue";
import Spinner from "../../shared/components/Spinner.vue";
import Modal from "../../shared/components/Modal.vue";

export default {
	components: { Modal, Spinner, InputTextArea },
	props: {
		show: {
			type: Boolean,
			default: true,
		},
		comprobante: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			form: {
				motivo: "",
			},
			loading: false,
			flags: {
				reload: false,
			},
		};
	},
	methods: {
		async onAnular() {
			const validated = await this.$refs.form.validate();

			if (!validated) return;

			const { isConfirmed } = await this.$swal.fire({ html: "¿Estás seguro de realizar esta acción?", icon: "warning", showCancelButton: true });
			if (!isConfirmed) return;

			this.loading = true;

			try {
				await this.axios.post(`/comprobantes/${this.comprobante.idComprobante}/anular`, {
					motivo: this.form.motivo,
				});

				await this.$swal.fire({ html: "Comunicación de baja realizada", icon: "success" });

				window.location.reload();
        
			} catch (error) {
				console.error(error?.response || error);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
